import { Colors, Services, upperFirst } from '@sigma-frontend-libs/commons'

import { buttonModes, components, moderationColors, moderationIcons } from '@/utils'

import button from '@/components/button'
import squircle from '@/components/icon/squircle'
import info from '@/components/info'
import selectorSendingType from '@/components/selector/sendingType'
import tag from '@/components/tag'

function renderTypes(h) {
  if (this.hasTypes) {
    return h(
      selectorSendingType,
      {
        props: {
          value: this.type,
          permission: `advanced.${Services.users}.update`,
          clearable: false
        },
        on: {
          input: event => {
            this.type = event
          }
        }
      }
    )
  }

  return h(
    info,
    {
      props: {
        value: this.getTranslate('users.warnings.noTypes'),
        color: Colors.warning
      }
    }
  )
}

function renderCheckSwitch(h, service) {
  return h(
    components.switch,
    {
      props: {
        value: this.checks[service][this.type],
        label: this.getTranslate(`${Services.users}.labels.strict.${this.checks[service][this.type]}`),
        tooltip: this.getTranslate(`${Services.users}.tooltips.strict.${service}`),
        disabled: !this.getGranularWritePermission(this.makeSettingPath(service)),
        outline: true
      },
      key: `switch-${service}-${this.type}`,
      on: {
        input: event => {
          this.$set(this.checks[service], this.type, event)
        }
      }
    }
  )
}
function renderCheckButton(h, service) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate('misc.buttons.save'),
        mode: buttonModes.flat,
        color: Colors.primary,
        disabled: this.isCheckButtonDisabled(service),
        loading: this.loading.set[service]
      },
      key: `button-${service}-${this.type}`,
      on: {
        click: () => {
          this.updateSetting(service)
        }
      }
    }
  )
}
function renderCheck(h, service) {
  if (!this.checkGranularPermissions(this.makeSettingPath(service), [ false ])) {
    return h(
      'div',
      {
        class: 'grid grid-gap--8',
        style: { 'grid-template-columns': '1fr auto' }
      },
      [
        renderCheckSwitch.call(this, h, service),
        renderCheckButton.call(this, h, service)
      ]
    )
  }

  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${Services.users}.warnings.permissions.strict.${service}`),
        color: Colors.warning
      }
    }
  )
}

function renderSelectSelection(h, item, removeByValue, service) {
  const { itemTitle } = this.selectPropsByService[service]

  return h(
    tag,
    {
      props: {
        label: item[itemTitle],
        color: moderationColors[item.moderation],
        tooltip: this.getTranslate(`misc.moderation.${item.moderation}`),
        as: 'select-dense',
        cancelable: true,
        cancel: () => {
          return removeByValue(item)
        }
      },
      key: item.id
    }
  )
}
function renderSelectItem(h, item, service) {
  const { itemTitle } = this.selectPropsByService[service]

  return h(
    'div',
    {
      class: 'faic grid-gap--8'
    },
    [
      h(
        squircle,
        {
          props: {
            icon: moderationIcons[item.moderation],
            color: moderationColors[item.moderation],
            tooltip: this.getTranslate(`misc.moderation.${item.moderation}`)
          }
        }
      ),

      item[itemTitle]
    ]
  )
}
function renderSelect(h, service) {
  const associationName = upperFirst(service)

  return h(
    components.select,
    {
      props: {
        ...this.selectPropsByService[service],
        value: this.proxy[associationName][this.type]
      },
      key: `select-${service}-${this.type}`,
      scopedSlots: {
        selection: ({ item, removeByValue }) => {
          return renderSelectSelection.call(this, h, item, removeByValue, service)
        },
        item: ({ item }) => {
          return renderSelectItem.call(this, h, item, service)
        }
      },
      on: {
        input: event => {
          this.$set(this.proxy[associationName], this.type, event)
        }
      }
    }
  )
}

function renderFields(h) {
  if (this.hasTypes) {
    return h(
      'div',
      {
        class: 'grid grid-gap--12'
      },
      [
        this.services.map(service => {
          return h(
            components.card,
            {
              class: 'grid grid-gap--8 pa-2',
              props: {
                title: this.getTranslate(`services.${service}`),
                outline: true,
                rounded: true
              }
            },
            [
              renderCheck.call(this, h, service),
              renderSelect.call(this, h, service)
            ]
          )
        })
      ]
    )
  }
}

function renderInfo(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${Services.users}.infos.associationsByType`)
      }
    }
  )
}

export default function(h) {
  return h(
    components.card,
    {
      class: 'grid grid-gap--12 pa-2',
      props: {
        outline: true,
        rounded: true
      }
    },
    [
      renderTypes.call(this, h),
      renderFields.call(this, h),
      renderInfo.call(this, h)
    ]
  )
}
